import React from "react";
import { Flag } from "lucide-react";

const RANK_CLS = ["bg-[#E11D48] text-white", "bg-[#F59E0B] text-white", "bg-[#0025D8] text-white"];

/**
 * Ranked list of proctoring flag types by interviews affected.
 * `ranking` = [{ type, label, interviews, pct }] (already sorted, top N).
 */
export default function FlagRanking({ ranking = [], title = "Most common flags", subtitle }) {
  const max = Math.max(1, ...ranking.map((r) => r.interviews));

  return (
    <div>
      <div className="flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.15em] text-muted-foreground mb-3">
        <Flag className="w-3.5 h-3.5" /> {title}
        {subtitle ? <span className="normal-case tracking-normal text-muted-foreground/70">· {subtitle}</span> : null}
      </div>

      {ranking.length === 0 ? (
        <p className="text-xs text-muted-foreground py-2">No proctoring flags recorded yet.</p>
      ) : (
        <div className="space-y-2">
          {ranking.map((r, i) => (
            <div key={r.type} className="flex items-center gap-2.5">
              <span className={`w-5 h-5 flex items-center justify-center rounded font-mono text-[10px] font-bold flex-shrink-0 ${RANK_CLS[i] || "bg-secondary text-muted-foreground"}`}>
                {i + 1}
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2 mb-0.5">
                  <span className="text-sm font-medium text-[#0F172A] truncate">{r.label}</span>
                  <span className="font-mono text-[11px] text-muted-foreground flex-shrink-0">
                    {r.interviews} iv · {r.pct}%
                  </span>
                </div>
                <div className="h-1.5 rounded-full bg-secondary overflow-hidden">
                  <div className="h-full rounded-full bg-[#E11D48]/70" style={{ width: `${Math.round((r.interviews / max) * 100)}%` }} />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
